import {UserEventsMap} from '../UserEventsMap'
import {getCurrentRelativeLinkWithoutQuery} from '../../atUtils'

let startDate = Date.now()

export default function handlePageVisited(event, params) {
    const path = getCurrentRelativeLinkWithoutQuery()

    if (event === UserEventsMap.PAGE_VISIBLE) {
        startDate = Date.now()
    } else if (event === UserEventsMap.PAGE_HIDDEN) {
        const endDate = Date.now()
        const duration = (endDate - startDate) / 1000
        startDate = endDate

        return  {
            event: UserEventsMap.PAGE_VISITED,
            params: {
                Duration: duration,
                'Tab Name': path
            }
        }
    }

    return { event, params }
}



// WEBPACK FOOTER //
// ./web/js/userEvents/handlers/handlePageVisited.js